import { render, staticRenderFns } from "./pptCheck.vue?vue&type=template&id=570af2e7&scoped=true&"
import script from "./pptCheck.vue?vue&type=script&lang=js&"
export * from "./pptCheck.vue?vue&type=script&lang=js&"
import style0 from "./pptCheck.vue?vue&type=style&index=0&id=570af2e7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570af2e7",
  null
  
)

export default component.exports